import { Component, AfterViewInit, Renderer2, Inject, OnInit } from '@angular/core';
import { AuthenticationService,CompanyService, FormService, AlertService,ProfileService } from '../../_services/index';
import { environment } from '../../../environments/environment';
import { FormGroup, FormControl,Validators } from '@angular/forms';
import * as Prism from 'prismjs';
import {Router, ActivatedRoute} from "@angular/router"
import { DOCUMENT } from '@angular/platform-browser';
import { ThemeService } from 'ng2-charts';
@Component({
  selector: 'app-company',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {
    public authorized:any;
    public form:any;
    public idCompany:any=[];
    public param:any={
        page:1,
        offset:1000,
        orderby:"[['name','ASC']]"
    };
    public users:any;
    public bussiness:any;
    public questionList:any;
    public lastQuestion:any=[];
    public idQuestion:any;
    public a:any;
    public totalValue:number=0;
    public risk={
        maximum: 0,
        minimum: 0,
        risk: {}
    }
    constructor(
        public as: AuthenticationService,
        public alertService:AlertService,
        public formService: FormService,
        public companyService:CompanyService,
        public profileService: ProfileService,
        private route: ActivatedRoute,
        private router: Router,
        @Inject(DOCUMENT) private _document,
    ){
        this.authorized = this.as.checkAuthentication();
        if(!this.authorized.authorized){
            this.router.navigate(['/login'])
        }
    }

    ngOnInit() {
        this.companyService.getBussiness(this.param).subscribe(response => {
            this.bussiness = response;
        });
        this.formService.getQuestionList().subscribe(response => {
            this.questionList = response; 
            if (this.route.snapshot.params && this.route.snapshot.params.token) {
                this.getForm(this.route.snapshot.params.token)
            }else{
                this.form = {
                    name:'',
                    company:'',
                    question:{},
                    risks: [
                        {
                            maximum: 0,
                            minimum: 0,
                            risk: {
                                id: 1,
                                name: "Sin riesgo"
                            }
                        },
                        {
                            maximum: 0,
                            minimum: 0,
                            risk: {
                              "id": 2,
                              "name": "Bajo"
                           }
                        },
                        {
                            maximum: 0,
                            minimum: 0,
                            risk: {
                              "id": 3,
                              "name": "Medio"
                           }
                        },
                        {
                            maximum: 0,
                            minimum: 0,
                            risk: {
                              "id": 4,
                              "name": "Alto"
                           }
                        }
                    ]
                }
            }
        }, error => {
        })
        
    }
    saveQuestions(item,type){
        if(this.form.questions.length > 0){
            for (let ii = 0; ii < this.form.questions.length; ii++) {
                if(this.form.questions[ii].id == item.id){
                    if(type == 'last'){
                        if(this.form.questions[ii].defaultWeighted){
                            item.defaultWeighted = this.form.questions[ii].defaultWeighted;
                        }
                        this.form.questions[ii] == item; 
                    }else if(type == 'list'){
                        this.form.questions[ii].defaultWeighted = item.defaultWeighted;
                    }
                    return
                }else if(this.form.questions.length == ii+1){
                    console.log('save-'+type,item.id)
                    this.form.questions.push(item)
                }
            }
        }else{
            this.form.questions.push(item)  
        }
    }
    changeValue(data){
        this.form.questions = [];
        data.forEach(select => {
            this.lastQuestion.forEach(question => {
                if(question.deleted){
                    question.deleted = false;
                }
                if(select == question.id){
                    this.saveQuestions(question,'last');
                }
            });
            this.questionList.forEach(question => {
                if(select == question.id){
                    this.saveQuestions(question,'list');
                }
            });
            
        });
        this.totalValue = 0;
        if(this.form.questions){
            for (let i = 0; i < this.form.questions.length; i++) {
                this.totalValue += this.form.questions[i].defaultWeighted;
            }
        }else{
            this.totalValue = 0;
        }
    }
    getForm(data){
        this.formService.getFormOne(data).subscribe(response => {
            this.form = response;
            this.lastQuestion = this.form.questions;
            if(this.questionList){
                this.idQuestion = []
                this.form.questions.forEach(fqa => {
                    this.questionList.forEach(lqa => {
                        if(fqa.id == lqa.id){
                            this.idQuestion.push(lqa.id)
                        }
                    });
                });
            }
            if(this.bussiness && this.bussiness.rows){
                this.idCompany = []
                this.bussiness.rows.forEach(lqa => {
                    if(this.form.company.id == lqa.id){
                        this.idCompany = lqa.id
                    }
                });
            }
            this.changeValue(this.idQuestion)
            if(this.form && !this.form.risks){
                this.form.risks =[
                {
                    maximum: 0,
                    minimum: 0,
                    risk: {
                        id: 1,
                        name: "Sin riesgo"
                    }
                },
                {
                    maximum: 0,
                    minimum: 0,
                    risk: {
                        "id": 2,
                        "name": "Bajo"
                    }
                },
                {
                    maximum: 0,
                    minimum: 0,
                    risk: {
                        "id": 3,
                        "name": "Medio"
                    }
                },
                {
                    maximum: 0,
                    minimum: 0,
                    risk: {
                        "id": 4,
                        "name": "Alto"
                    }
                }]
            }
            
            if(!response){
                this.alert({reason:'No se ha podido cargar el formulario.', type:"danger"});
                this.router.navigate(['/formularios']);
            }
        }, error => {
            this.alert({reason:'No se ha podido cargar el formulario.', type:"danger"});
            this.router.navigate(['/formularios']);
        })
    }
    riskname(data){
        var risk =[
            {
                maximum: 0,
                minimum: 0,
                risk: {
                    id: 1,
                    name: "Sin riesgo"
                }
            },
            {
                maximum: 0,
                minimum: 0,
                risk: {
                    "id": 2,
                    "name": "Bajo"
                }
            },
            {
                maximum: 0,
                minimum: 0,
                risk: {
                    "id": 3,
                    "name": "Medio"
                }
            },
            {
                maximum: 0,
                minimum: 0,
                risk: {
                    "id": 4,
                    "name": "Alto"
                }
            }]
        for (let ii = 0; ii < risk.length; ii++) {
            if(risk[ii].risk.id == data){
                return risk[ii].risk.name;
            }
        }
    }
    delete(){
        this.formService.deleteFormOne(this.form).subscribe(response => {
            this.alert({reason:'El formulario ha sido eliminada con éxito.', type:"success"});
            this.router.navigate(['/formularios']);
        }, error => {
            this.alert({reason:'El formulario no ha sido eliminada, intentalo nuevamente.', type:"danger"});
        })
    }
    getSave(){
        if(this.bussiness && this.bussiness.rows){
            this.form.company = {}
            this.bussiness.rows.forEach(lqa => {
                if(this.idCompany == lqa.id){
                    this.form.company = lqa
                }
            });
        }
        if(this.route.snapshot.params.token){
            this.lastQuestion.forEach(last => {
                for (let iii = 0; iii < this.form.questions.length; iii++) {
                    if(this.form.questions[iii].id == last.id){
                        return
                    }else if(this.form.questions.length == iii+1){
                        last.deleted = true;
                        this.saveQuestions(last,'last');
                    }
                }
            });
            this.formService.updateFormOne(this.form).subscribe(response => {
                this.alert({reason:'El formulario ha sido actualizado con éxito.', type:"success"});
                this.router.navigate(['/formularios']);
            }, error => {
                this.alert({reason:'El formulario no ha sido actualizado, intentalo nuevamente.', type:"danger"});
            })
        }else{
            this.form.active = true;
            this.formService.newFormOne(this.form).subscribe(response => {
                this.alert({reason:'El formulario ha sido creado con éxito.', type:"success"});
                this.router.navigate(['/formularios']);
            }, error => {
                this.alert({reason:'El formulario no ha sido creado, intentalo nuevamente.', type:"danger"});
            })
        }
    }
    url(path){
        this.router.navigate([path]);
      }
    alert(data){
        this.alertService.updateAlert(data).subscribe(()=>{
            setTimeout(() => {
            this.alertService.deleteAlert().subscribe();
            }, 8000);
        })
    }
    
}

